import { createSelector } from "reselect";

const getWeillCornell = (state) =>
  state?.variantResult?.weill_cornell_medicine_pmkb;
const getWustlCivic = (state) => state?.variantResult?.wustl_civic;
const getJaxCkb = (state) => state?.variantResult?.jax_ckb;
const getIcgcSomatic = (state) => state?.variantResult?.icgc_somatic;
const getSangerCosmicPublic = (state) =>
  state?.variantResult?.sanger_cosmic_public;
const getSangerCosmicLicensed = (state) =>
  state?.variantResult?.sanger_cosmic_licensed;
const getIarcTp53Somatic = (state) => state?.variantResult?.iarc_tp53_somatic;
const getIarcTp53Germline = (state) => state?.variantResult?.iarc_tp53_germline;
const getNihGdc = (state) => state?.variantResult?.nih_gdc;
const getCbioPortal = (state) => state?.variantResult?.cbio_portal;
const getCancerHotspots = (state) =>
  state.variantResult && state.variantResult.cancer_hotspots;

const displayCancerSamples = createSelector(
  getIcgcSomatic,
  getIarcTp53Somatic,
  getIarcTp53Germline,
  getNihGdc,
  getCbioPortal,
  getCancerHotspots,
  (
    icgcSomatic,
    iarcTp53Somatic,
    iarcTp53Germline,
    nihGdc,
    cbioPortal,
    cancerHotspots
  ) => {
    return Boolean(
      icgcSomatic ||
        iarcTp53Somatic ||
        iarcTp53Germline ||
        nihGdc ||
        cbioPortal ||
        cancerHotspots
    );
  }
);
const getTotalSamples = createSelector(
  getIcgcSomatic,
  getIarcTp53Somatic,
  getIarcTp53Germline,
  getNihGdc,
  getCbioPortal,
  getCancerHotspots,
  (
    icgcSomatic,
    iarcTp53Somatic,
    iarcTp53Germline,
    nihGdc,
    cbioPortal,
    cancerHotspots
  ) => {
    const sources = [
      icgcSomatic,
      iarcTp53Somatic,
      iarcTp53Germline,
      nihGdc,
      cbioPortal,
      cancerHotspots,
    ];
    return sources.reduce((total, source) => {
      if (source && source[0]) {
        if (source === icgcSomatic) {
          return total + (source[0].affected_donors || 0);
        }
        return total + (source[0].total_samples || 0);
      }
      return total;
    }, 0);
  }
);

const getActiveDatabases = createSelector(
  getIcgcSomatic,
  getIarcTp53Somatic,
  getIarcTp53Germline,
  getNihGdc,
  getCbioPortal,
  getCancerHotspots,
  (
    icgcSomatic,
    iarcTp53Somatic,
    iarcTp53Germline,
    nihGdc,
    cbioPortal,
    cancerHotspots
  ) => {
    const sources = [
      icgcSomatic,
      iarcTp53Somatic,
      iarcTp53Germline,
      nihGdc,
      cbioPortal,
      cancerHotspots,
    ];
    return sources.filter(Boolean).length;
  }
);

export {
  getWeillCornell,
  getWustlCivic,
  getJaxCkb,
  getIcgcSomatic,
  getSangerCosmicPublic,
  getSangerCosmicLicensed,
  getIarcTp53Somatic,
  getIarcTp53Germline,
  getNihGdc,
  getCbioPortal,
  displayCancerSamples,
  getTotalSamples,
  getActiveDatabases,
};
